// extracted by mini-css-extract-plugin
export default {"cash_fund_preferences_info":"PaypalMeHelpText-styles__cash_fund_preferences_info__iNaE3"};